import React, { useEffect } from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Landing } from './components/landing/Landing';
import { Services } from './components/services/Services';
import { EndOfTenancy } from './components/end-of-tenancy/EndOfTenancy';
import {About} from './components/about/About';
import { Testimonials } from './components/testimonials/Testimonials';
import { Contact } from './components/contact/Contact';
import { EndOfTenancyPage } from './components/end-of-tenancy/EndOfTenancyPage';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  const HomePage = () => (
    <div className="App">
      <Landing />
      <Services />
      <EndOfTenancy />
      <About />
      <Testimonials />
      <Contact />
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/end-of-tenancy-cleaning-tunbridge-wells" element={<EndOfTenancyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
